import { Component, OnInit } from '@angular/core';
import { USER_LEVEL } from '../../../constants/user.level.constants';
import { prepInstructions } from 'src/app/constants/app.constants';
import { APP_USER_PERMISSIONS } from 'src/app/constants/app-user-permissions.constants';
import { MfaService } from 'src/app/services/core/mfa.service';

@Component({
	selector: 'app-questions',
	templateUrl: './questions.component.html',
	styleUrls: ['./questions.component.scss'],
})
export class QuestionsComponent implements OnInit {
	isMatchedUser: boolean;
	USER_LEVEL = USER_LEVEL;
	MODULE_LEVEL = APP_USER_PERMISSIONS;
	prepInstructions = prepInstructions;
	// TODO: Declared but not used
	c2;
	constructor(private mfaService: MfaService) {}

	ngOnInit() {
		this.isMatchedUser = localStorage.getItem('isMatchedUser') === 'true';
	}

	getGlobalMfaStatus() {
		return this.mfaService.ss_getGlobalMfaStatus();
	}
}
